export default __webpack_public_path__ + "static/media/testimg.18fa430a.JPG";